import { render, staticRenderFns } from "./ReplyTrendyolQuestion.vue?vue&type=template&id=1115c612"
import script from "./ReplyTrendyolQuestion.vue?vue&type=script&lang=js"
export * from "./ReplyTrendyolQuestion.vue?vue&type=script&lang=js"
import style0 from "./ReplyTrendyolQuestion.vue?vue&type=style&index=0&id=1115c612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports